import { IMaskMixin } from 'react-imask'
import { AnyMaskedOptions, MaskElement } from 'imask'
import { TextField, TextFieldProps, Typography } from '@mui/material'
import { get } from 'lodash'
import { useContext } from 'react'
import { FormContext } from '../Contexts'

export type { AnyMaskedOptions }

export const TextMaskField = IMaskMixin<
  AnyMaskedOptions,
  boolean | 'typed',
  string,
  MaskElement | HTMLTextAreaElement | HTMLInputElement,
  TextFieldProps & { name: string }
>(({ inputRef, name, label, required, variant, ...rest }) => {
  const { formState } = useContext(FormContext)
  const error = get(formState?.errors, name)

  return (
    <>
      <TextField
        name={name}
        label={label}
        variant={variant || 'standard'}
        fullWidth
        inputRef={inputRef}
        required={required}
        error={!!error}
      />
      <Typography variant="inherit" color="red" align="left" style={{ marginTop: 10 }}>
        {error?.message?.toString()}
      </Typography>
    </>
  )
})
